const colorHexMap = {
  black: "#000000",
  white: "var(--color-semantic-neutral-surface-clear)",
  grey: "var(--color-semantic-neutral-surface-softer)"
};
export {
  colorHexMap
};
//# sourceMappingURL=color-map.js.map
